<template>
    <Icon
        name="loader"
        :class="$style.loader"
    />
</template>

<script setup lang="ts">
import Icon from '@/components/Icon/Icon.vue'
</script>

<style module>
.loader {
    animation: loader-spin 1s infinite steps(8, end);
    transform-origin: 48% 50%;
}

@keyframes loader-spin {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
